import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import { deviceSize } from "../responsive";
import { useMediaQuery } from "react-responsive";
import { faLinkedin, faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

 

//images
import ESD from "../../images/ESD.png";
import SBA from "../../images/SBA.png";
import NYCSB from "../../images/NYCSmallBusiness.png";
import WO from "../../images/Womenowned.png";
import WBE from "../../images/WBE.jpg";
import DBE from "../../images/DBE.jpg";


const FooterContainer = styled.div`
  width: 100%;
  min-height:400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2em 3em;
  background: linear-gradient(180deg, #F9E9E9 0%, rgba(249, 233, 233, 0.00) 100%);






 @media screen and (max-width: 768px) {
    padding: 2em 12px;
    width:100%;
    height:600px;

  }


`;

const TopContainer = styled.div`
	width:100%;
	display:flex;
	margin-bottom:1em;
  justify-content: center;
  height: 220px;
  margin-bottom: 10%;
  z-index: 1;



  @media screen and (max-width: 768px){
    display: grid;
    grid-template-columns: repeat(2, 1fr); 
    grid-gap: 1em;
    /* height: 900px; */
    height: 100%;


    & > * {
      width: 50%;
      box-sizing: border-box;
      padding: 0 10px;
    }
  }

`;

const ContentContainer =styled.div`
		display:flex;
		flex-direction: column;
    flex-wrap: wrap;
		align-items:flex-start;
    height: 85%;


		&:not(:last-of-type){
			margin-right:5%;
		}


		@media screen and (max-width: 768px) {
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 0px;
    height: auto;


    }
 `;

const MiddleContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
 `;


  // const ImageGallery = styled.div`
  //     display: flex;
  // 		/* width: 60%; */
  //     height: 30%;
  // 		justify-content:space-evenly;

    
  //     img{
  //   	/* width: 35%; */
  //   	/* height:30%; */
  //   	margin:10px;
  //     }


	// @media screen and (max-width: ${deviceSize.tablet}px) {
     
  //   width:100%;
  //   margin-left:0;
  //   margin-right:0;
  //   display:flex;

  //  img{   
    
  //    width: 30%;
  //  	 height: 28%;
   
  //  }

  // }


	// @media screen and (max-width: ${deviceSize.mobile}px) {
    
  //   	width:100%;
  //   	height:13em;
  //   	justify-content:space-evenly;
  //   	margin:auto;
  //     flex-direction: column;
  //     flex-wrap: wrap;
  //     display: contents;

  //   img{
    	
  //     width:30%;
  //   	height:44%;
  //   	margin:10px;
    
  //    }


  //  }
  // `;

  const ImageGallery = styled.div`
  display: flex;
  flex-wrap: wrap; /* Allow images to wrap into rows */
  justify-content: center; /* Center the items */
  align-items: center;
  gap: 10px; /* Add consistent spacing between items */
  max-width: 100%;
  width: 100%; /* Ensure it takes the full width of the container */
  margin: 0 auto;

  img,
  a img {
    width: 15%; /* Set a base size for images */
    max-width: 150px; /* Limit the maximum size */
    height: 44%; /* Maintain aspect ratio */
    margin: 10px;
    object-fit: contain; /* Ensure images scale proportionally */
  }

  /* Adjust for tablets */
  @media screen and (max-width: 768px) {
    img,
    a img {
      width: 25%; /* Make images larger on smaller screens */
      height: 20%;
      grid-template-columns: repeat(4, 1fr); /* 4 items per row */
    }
  }

`;

 const BottomContainer=styled.div` 

  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  padding: 0 10px;
  width:100%;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    padding: 0;
    justify-content: center;

   }

 `;

const Title = styled.h2`
   margin: 0;
   margin-bottom: 12px ;
   color:#000 ;
   text-align:left;
   font-family: Sunflower;
	 font-style: normal;
	 font-weight: 500;
   font-size: 18px;
   line-height: 28px;


 @media screen and (max-width: ${deviceSize.mobile}px) {
  	font-size: 13px;
  	width: 100px;
    white-space:nowrap;
  }
  
   @media screen and (max-width: ${deviceSize.mmobile}px) {
  	font-size: .6em;
  	width: 100px;
    white-space:nowrap;
  }
 `;

const Flink = styled.a`

text-decoration: none;
color:#000000;
 
align-items:flex-start;
text-align:left;
font-family: Roboto;
font-style: normal;
font-weight: 100;
font-size: 12px;
line-height: 30px;



&:not(:last-of-type){
	margin-bottom: -8px;
}


@media screen and (max-width:${deviceSize.tablet}px){

	width:50%;
}


@media screen and (max-width: ${deviceSize.mobile}px){
	      
    align-items:flex-startd;
    font-size: 8px;
    text-align:left;
    width: 100%;
 
}


`;

const PrivacyText = styled.h6`

  margin: 9px 0 6px 6px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8a8a8a;

   @media screen and (max-width: ${deviceSize.mobile}px) {
   
  }

`;



const FooterText =styled.p`

  margin: 0 14px 0 0;
  font-family: 'Red Rose';
  font-size: 22px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8a8a8a;


@media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 11px;
    width:171px;
  }


`;

const BBBBadge = styled.a`
  display: block;
  margin: 10px;
  text-align: center;

  img {
    width: auto !important; /* Remove width constraints */
    height: auto !important; /* Remove height constraints */
    max-width: 200px; /* Optional: Add a max-width for scaling */
    max-height: 65px; /* Optional: Keep proportions */
    border: 0;
  }
`;




export function Footer(props){
const isMobile = useMediaQuery ({maxWidth:deviceSize.mobile});


		return(
			<FooterContainer>
				
				<TopContainer id="top-container">
          <ContentContainer>
            <Title>Contact Us</Title>
            <Flink href="mailto:info@exp-staffing.com">
              <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '5px' }} />
              info@exp-staffing.com
            </Flink>
            <Flink href="https://www.linkedin.com/company/expedientstaffingsolutions/" target="_blank">
              <FontAwesomeIcon icon={faLinkedin} style={{ marginRight: '5px' }} />
              LinkedIn
            </Flink>
            <Flink href="https://instagram.com/exp_staffing?igshid=MzRlODBiNWFlZA==" target="_blank">
              <FontAwesomeIcon icon={faInstagram} style={{ marginRight: '5px' }} />
              Instagram
            </Flink>
            <Flink href="https://www.facebook.com/expstaffing">
              <FontAwesomeIcon icon={faFacebook} style={{ marginRight: '5px'}} />
              Facebook
            </Flink>
          </ContentContainer>

          <ContentContainer>
            <Title>Quick Links</Title>
            <Flink href="/staffing">staffing</Flink>
            <Flink href="/careers">careers</Flink>
            <Flink href="/getfoodnyc">getfood nyc</Flink>
            <Flink href="/blogs">blog</Flink>
            <Flink href="/">about expedient</Flink>
            <Flink href="/privacy-policy">privacy policy</Flink>
          </ContentContainer>

					<ContentContainer>
						<Title>Services</Title>
						<Flink>payroll master</Flink>
            <Flink>try buy / right to hire</Flink>
            <Flink>contract / temp labor</Flink>
            <Flink>managed workforce programs</Flink>
            <Flink>cost-saving workforce solutions</Flink>
            <Flink>health compliance</Flink>
					</ContentContainer>
					
					<ContentContainer>
              <Title>Talent Industries</Title>
              <Flink>information technology</Flink>
              <Flink>finance / accounting</Flink>
              <Flink>call center operations</Flink>
              <Flink>clerical / administrative</Flink>
              <Flink>nyc / ny state agencies</Flink>
              <Flink>engineering</Flink>
              <Flink style={{ paddingTop: isMobile ? '0' : '40px' }}>insurance</Flink>
              <Flink>media</Flink>
              <Flink>advertising</Flink>
              <Flink>government</Flink>
              <Flink>utilities</Flink>
					</ContentContainer>
				</TopContainer>

        <MiddleContainer>
          <ImageGallery>
						{/* <img src={ESD} alt=""/> */}
						<img src={WO} alt="WO"/>
						<img src={NYCSB} alt="NYCSB"/>
					  <img src={SBA} alt="SBA"/>
            <img src={ESD} alt="ESD"/>
            <BBBBadge
              href="https://www.bbb.org/us/ny/staten-island/profile/staffing-agencies/expedient-staffing-solutions-inc-0121-87176062/#sealclick"
              target="_blank"
              rel="nofollow"
            >
              <img
                src="https://seal-newyork.bbb.org/seals/blue-seal-200-65-bbb-87176062.png"
                alt="Expedient Staffing Solutions, Inc BBB Business Review"
              />
            </BBBBadge>
            <img src={WBE} alt="WBE"/>
            <img src={DBE} alt="DBE"/>
					</ImageGallery>
        </MiddleContainer>

					
			
				<BottomContainer>
				    <FooterText>Expedient Staffing Solutions, Inc.</FooterText>
						<PrivacyText> &#169; All Rights Reserved.{new Date().getFullYear()} </PrivacyText>
				</BottomContainer>

			</FooterContainer>
			);
}





